import React, { Component } from "react";
import { Badge, Box, CircularProgress } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "@reach/router";
import { invalidateQueueCache, loadQueueCounts } from "./queueApi";
import { emptyQueueSummary, normalizeLane, taskManagerHref } from "./queueModel";
import { LANE_META, laneCount, QueueCountBadge, laneHelpContent, laneTitle } from "./QueueLaneTiles";
import QueueHeaderTooltip from "./QueueHeaderTooltip";
import { withTranslation } from "react-i18next";

function laneFromSearch(search) {
  if (!search) return "";
  try {
    return new URLSearchParams(search).get("lane") || "";
  } catch (e) {
    return "";
  }
}

class QueueNavItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      summary: emptyQueueSummary(),
      countsLoaded: false,
    };
    this.pollId = null;
    this.bootId = null;
    this.loadSummary = this.loadSummary.bind(this);
  }

  componentDidMount() {
    var self = this;
    this.handleQueueSync = function () {
      invalidateQueueCache();
      self.loadSummary();
    };
    this.bootId = window.setTimeout(function () {
      self.loadSummary();
      self.pollId = window.setInterval(self.loadSummary, 60000);
    }, 800);
    if (typeof window !== "undefined") {
      window.addEventListener("pickup-change-tasks-updated", this.handleQueueSync);
    }
  }

  componentWillUnmount() {
    if (this.bootId) window.clearTimeout(this.bootId);
    if (this.pollId) window.clearInterval(this.pollId);
    if (typeof window !== "undefined" && this.handleQueueSync) {
      window.removeEventListener("pickup-change-tasks-updated", this.handleQueueSync);
    }
  }

  loadSummary() {
    var self = this;
    loadQueueCounts()
      .then(function (result) {
        self.setState({ summary: result.summary, countsLoaded: true });
      })
      .catch(function () {
        self.setState({ countsLoaded: true });
      });
  }

  render() {
    var props = this.props;
    var classes = props.classes || {};
    var location = props.location || {};
    var drawerOpen = props.drawerOpen !== false;
    var wrapNavTitle = props.wrapNavTitle;
    var pathname = location.pathname || "";
    var activeLane =
      pathname.indexOf("/home/taskmanager") !== -1
        ? normalizeLane(laneFromSearch(location.search))
        : "";

    var countsLoading = !this.state.countsLoaded;
    return (
      <Box data-testid="queue-nav-items">
        {LANE_META.map(function (lane) {
          var Icon = lane.icon;
          var count = laneCount(this.state.summary, lane.id);
          var href = taskManagerHref("", "", lane.id);
          var selected = activeLane === lane.id;
          var item = (
            <QueueHeaderTooltip
              wide
              block
              placement="right"
              title={laneHelpContent(lane, props.t)}
            >
            <Link to={href} className={classes.navLink}>
              <ListItemButton
                className={
                  classes.listItem +
                  (classes.primaryNavItem ? " " + classes.primaryNavItem : "")
                }
                selected={selected}
                data-testid={"queue-nav-" + lane.id}
              >
                <ListItemIcon className={classes.navItemIcon}>
                  {drawerOpen ? (
                    <Icon fontSize="small" />
                  ) : countsLoading ? (
                    <Box sx={{ position: "relative", width: 24, height: 24 }}>
                      <Icon fontSize="small" />
                      <CircularProgress
                        size={22}
                        thickness={4}
                        sx={{
                          position: "absolute",
                          top: -2,
                          left: -2,
                          color: "#0a5d66",
                        }}
                      />
                    </Box>
                  ) : (
                    <Badge
                      badgeContent={count}
                      color="error"
                      max={99}
                      invisible={!count}
                      overlap="circular"
                    >
                      <Icon fontSize="small" />
                    </Badge>
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={laneTitle(lane, props.t)}
                  className={classes.textColor}
                />
                {drawerOpen ? (
                  countsLoading ? (
                    <QueueCountBadge loading count={0} size={22} />
                  ) : count > 0 ? (
                    <QueueCountBadge count={count} size={22} />
                  ) : null
                ) : null}
              </ListItemButton>
            </Link>
            </QueueHeaderTooltip>
          );
          var wrapped = wrapNavTitle
            ? wrapNavTitle(laneTitle(lane, props.t), item)
            : item;
          return <React.Fragment key={lane.id}>{wrapped}</React.Fragment>;
        }, this)}
      </Box>
    );
  }
}

export default withTranslation()(QueueNavItems);



// WEBPACK FOOTER //
// ./src/components/workflowQueue/QueueNavItems.js